import ChevronDownIcon from './ChevronDownIcon'
import ChevronRightIcon from './ChevronRightIcon'

const icons = { ChevronRightIcon, ChevronDownIcon }
export default icons
